import { FC, ReactElement, useEffect, useState } from 'react';
import { Card, Grid, Paper } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { BakeasyAppBar } from '../../components/common/BakeasyAppBar';
import { t } from 'i18next';
import BakeasyLabelText from '../../components/lables/BakeasyLabelText';
import BakeasyCollapsibleTable, {
  CollapsibleTableHeadCell
} from '../../components/tables/BakeasyCollapsibleTable';
import {
  downloadConsolidateRecipeBuilder,
  fetchConsolidatedRecipe,
  fetchInnerConsolidatedRecipe,
  recipesState
} from '../../redux_store/slices/recipeBuilderSlice';
import { useAppDispatch, useAppSelector } from '../../redux_store/reduxStore';
import BakeasyEmptyMsg from '../../components/common/BakeasyEmptyMsg';
import { BakeasyButtonPrint } from '../../components/buttons/BakeasyButton';

export const ConsolidatedRecipeBuilder: FC = (): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const location = useLocation();
  const [recipeList, setRecipeList] = useState<any[]>([]);
  const [orderIdsList, setOrderIdsList] = useState<any>([]);
  const [recipeHistoryList, setRecipeHistoryList] = useState<any[]>([]);

  let { loading, error, outerValue, historyValue, pageNo, filter } = useAppSelector(recipesState);

  const refreshPageData = async (filter?: {} | undefined) => {
    let payload: any = {};

    if (filter != undefined && filter !== '') {
      payload = { ...payload, ...filter };
    }
    await dispatch(fetchConsolidatedRecipe(location?.state));
  };

  useEffect(() => {
    if (outerValue?.orderCount === -1) {
      refreshPageData();
    } else {
      setOrderIdsList(outerValue.orderIds);
      const filteredData = outerValue?.details?.map((item: any) => {
        return {
          id: item._id,
          icon: 'ICONN',
          onIconClick: () => {
            handleHistoryRowIconClick({
              ingredientId: item._id,
              requestedDeliveryToDate: location?.state?.requestedDeliveryToDate,
              requestedDeliveryFromDate: location?.state?.requestedDeliveryFromDate,
              viewAllOrders: location?.state?.viewAllOrders
            });
          },
          ingredientName: item.ingredientName,
          measureType: { measureType: { ...item.measurePerType } },
          units: item.measurePerUnit,
          totalRequired: item?.totalRequired,
          history: []
        };
      });

      setRecipeList(filteredData);
    }
  }, [outerValue]);

  const handleHistoryRowIconClick = async ({
    ingredientId,
    requestedDeliveryToDate,
    requestedDeliveryFromDate,
    viewAllOrders
  }: {
    ingredientId: any;
    requestedDeliveryFromDate?: any;
    requestedDeliveryToDate?: any;
    viewAllOrders?: any;
  }) => {
    const payload = {
      ingredientId,
      requestedDeliveryFromDate,
      requestedDeliveryToDate,
      viewAllOrders
    };
    await dispatch(fetchInnerConsolidatedRecipe({ ...location?.state, ingredientId }));
  };

  useEffect(() => {
    if (historyValue) {
      const filteredDataa = historyValue?.products?.map((product: any) => {
        return {
          productName: product?.productName,
          orderId: product?.orderId,
          productQuantity: product?.productQuantity,
          ingredientQuantity: product?.ingredientQuantity,
          totalRequired: product?.totalmult
        };
      });

      setRecipeHistoryList(filteredDataa);
      if (filteredDataa && filteredDataa.length > 0 && recipeList?.length > 0) {
        let p1: any = recipeList?.map((production: any) => production?._id === historyValue?._id);
        p1['history'] = filteredDataa;
        let sdf = recipeList;
        sdf?.forEach((production: any) => {
          if (production?.id === historyValue?._id) {
            production.history = filteredDataa;
          }
          return production;
        });
        setRecipeList(sdf);
      }
    }
  }, [historyValue]);

  const tableHeaders: CollapsibleTableHeadCell[] = [
    { id: 'productName', label: 'PRODUCT_NAME', width: '200px' },
    { id: 'productQuantity', label: 'PRODUCT_QUANTITY', width: '190px' },
    { id: 'ingredientQuantity', label: 'INGREDIENT_QUANTITY', width: '190px' },
    { id: 'totalRequired', label: 'TOTAL_REQUIRED', width: '190px' },
    { id: 'orderId', label: 'ORDER_ID' }
  ];

  const reportTableHeaders: CollapsibleTableHeadCell[] = [
    { id: 'icon', label: '', width: '40px' },
    { id: 'ingredientName', label: 'INGREDIENTS', width: '200px' },
    { id: 'measureType', label: 'MEASURE_TYPE', width: '120px' },
    { id: 'units', label: 'MEASURE_PER_UNITS', width: '120px' },
    { id: 'totalRequired', label: 'TOTAL_REQUIRED', width: '120px' }
  ];

  function consolidatedRecipeBuilderUI() {
    return (
      <Grid>
        <Grid item>
          <BakeasyAppBar
            title={t('CONSOLIDATED_RECIPE_BUILDER_BY_MULTIPLE_PRODUCT')}
            menus={
              <>
                <div className="tableOptions">
                  <BakeasyButtonPrint
                    onClick={function(
                      event: React.MouseEvent<HTMLButtonElement, MouseEvent>
                    ): void {
                      let temp: any = location?.state;
                      dispatch(downloadConsolidateRecipeBuilder({ ...temp, downloadType: 'pdf' }));
                    }}
                  />
                </div>
              </>
            }
            //description={f()}
            onBackClick={() => {
              navigate(-1);
            }}
          />
        </Grid>
        <Paper component={Card} variant="outlined" sx={{ p: 2, mt: 1 }}>
          <Grid container spacing={2}>
            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('TYPE')} value={'-'} />
            </Grid> */}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <BakeasyLabelText label={t('ORDER_ID')} value={orderIdsList?.toString()} />
            </Grid>

            {/* <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('PRODUCTION_DATE')} value={'-'} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('PRODUCTION_ID')} value={'-'} />
            </Grid>
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <BakeasyLabelText label={t('NOTE')} value={'-'} />
            </Grid> */}
          </Grid>
          <Grid item xs={12} marginTop={2}>
            {/* <BakeasyCollapsibleTable
              reportTableHeaders={reportTableHeaders}
              tableHeaders={tableHeaders}
              rowsData={rows}
            /> */}
          </Grid>
          <Grid item xs={12}>
            {recipeList && recipeList.length > 0 ? (
              <BakeasyCollapsibleTable
                reportTableHeaders={reportTableHeaders}
                tableHeaders={tableHeaders}
                rowsData={recipeList}
              />
            ) : (
              <BakeasyEmptyMsg message={t('NO_DATA_FOUND')} />
            )}
          </Grid>
          {/* </> */}
        </Paper>
      </Grid>
    );
  }

  return consolidatedRecipeBuilderUI();
};
